import { createFileRoute } from '@tanstack/react-router';
import GoodView from '../../../features/baseData/goods/good/view';
import {
  createPermissionGuard,
  getPermissionSet,
  GOODS_PERMISSIONS,
} from '@bmwe/ui';

export const Route = createFileRoute('/stammdaten/gueter/$goodId')({
  component: GoodView,
  beforeLoad: createPermissionGuard(
    getPermissionSet(GOODS_PERMISSIONS, 'READ'),
  ),
});

export const ViewGoodRoute = Route;
